var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "videoControlBox",
    class: {
      hideBackGround: !_vm.showOperate
    },
    attrs: {
      "id": "videoControlBox"
    }
  }, [_c('div', {
    ref: "controlDiv",
    staticClass: "controlBar",
    class: {
      hideIconList: !_vm.showIconArray
    }
  }, [_c('div', {
    staticClass: "playTime"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOperate && !_vm.unSubscribe,
      expression: "showOperate && !unSubscribe"
    }],
    style: {
      'display': !_vm.singChannel.id ? 'none' : ''
    }
  }, [_c('el-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.returnShow,
      expression: "returnShow"
    }],
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.rotate'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-controls",
    on: {
      "click": _vm.controlVideoRotate
    }
  })]), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.mirror'),
      "placement": "top"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.$route.name == 'party' && _vm.singChannel.id != _vm.outputRtilCode && _vm.deviceType === 'Anywhere',
      expression: "$route.name == 'party' && singChannel.id != outputRtilCode&&deviceType==='Anywhere'"
    }],
    staticClass: "iconfont icon-mirror1",
    on: {
      "click": _vm.hostAnywhereMirrorVideo
    }
  })])], 1)]), _c('div', {
    staticClass: "iconListBox",
    style: {
      'display': !_vm.singChannel.id ? 'none' : ''
    }
  }, [_vm.singChannel.id != _vm.userInfo.rtilCode && _vm.singChannel.audioTrack && !_vm.muteAudioIcon && _vm.showOperate || _vm.showVolumeIcon ? _c('span', {
    staticClass: "contentClass"
  }, [!_vm.mute ? _c('i', {
    staticClass: "voiceIcon iconfont icon-speakeron pointer",
    on: {
      "click": function ($event) {
        return _vm.setAudio('mute');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-speakeroff",
    class: {
      notAllowed: _vm.isMute
    },
    on: {
      "click": function ($event) {
        return _vm.setAudio('unmute');
      }
    }
  }), _c('el-slider', {
    staticClass: "voiceSlider",
    attrs: {
      "disabled": _vm.isMute,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.setVideoAudio
    },
    model: {
      value: _vm.voiceVal,
      callback: function ($$v) {
        _vm.voiceVal = $$v;
      },
      expression: "voiceVal"
    }
  })], 1) : _vm._e(), (_vm.$route.name == 'party' || _vm.$route.name == 'partyParticipate') && _vm.showOperate ? _c('span', [_vm.fullScreenLayout ? _c('i', {
    staticClass: "iconfont switchFullScreen icon-a-kongjianzuoyoubujuon pointer",
    on: {
      "click": _vm.switchFullScreen
    }
  }) : _c('i', {
    staticClass: "iconfont switchFullScreen icon-a-TypepipStateon pointer",
    on: {
      "click": _vm.switchFullScreen
    }
  })]) : _vm._e(), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOperate && !_vm.unSubscribe,
      expression: "showOperate && !unSubscribe"
    }]
  }, [!_vm.isFullScreen ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('galleryHost.fullScreen'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-full_screen",
    on: {
      "click": _vm.fullScreen
    }
  })]) : _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('galleryHost.exitFullScreen'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-ExitFullScreen",
    on: {
      "click": _vm.fullScreen
    }
  })])], 1), _c('span', [_c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.pictureInpicture'),
      "placement": "top"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOperate && !_vm.unSubscribe && _vm.singChannel.videoTrack,
      expression: "showOperate && !unSubscribe && singChannel.videoTrack"
    }],
    staticClass: "iconfont icon-huazhonghua-01 pointer",
    on: {
      "click": _vm.setPictureInpicture
    }
  })])], 1)]), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "300",
      "popper-class": "sideTips videoControl",
      "trigger": "click",
      "visible-arrow": "false"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "popupBox"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": _vm.fullScreen
    }
  }, [_c('i', {
    staticClass: "iconfont icon-quanping1 grayColor"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('btnText.fullScreen.text')))])]), _c('div', {
    staticClass: "pointer",
    on: {
      "click": function ($event) {
        return _vm.setAudio(_vm.mute ? 'unmute' : 'mute');
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: {
      'icon-speakeron': !_vm.mute,
      'icon-speakeroff': _vm.mute
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('conferenceHost.mute')))])]), _c('div', {
    staticClass: "pointer",
    on: {
      "click": _vm.setPictureInpicture
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.singChannel.videoTrack,
      expression: "singChannel.videoTrack"
    }],
    staticClass: "iconfont icon-huazhonghua-01"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('commonFunction.pictureInpicture')))])])]), _c('i', {
    staticClass: "iconfont icon-universal_3-dots",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFullScreen && _vm.showOperate,
      expression: "isFullScreen && showOperate"
    }]
  }, [_vm.showFootBar ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.bottomDown'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-down",
    on: {
      "click": _vm.controlFootBar
    }
  })]) : _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.$t('commonFunction.bottomUp'),
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-up",
    on: {
      "click": _vm.controlFootBar
    }
  })])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };